import { render, staticRenderFns } from "./PolygonSwitchControl.vue?vue&type=template&id=2b70845a&scoped=true"
import script from "./PolygonSwitchControl.vue?vue&type=script&lang=js"
export * from "./PolygonSwitchControl.vue?vue&type=script&lang=js"
import style0 from "./PolygonSwitchControl.vue?vue&type=style&index=0&id=2b70845a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b70845a",
  null
  
)

export default component.exports